declare var window: any;

export function getPerformanceAPI() {
  return (
    window.performance ||
    window.webkitPerformance ||
    window.msPerformance ||
    window.mozPerformance
  );
}

export function getPerformanceSupport(): Boolean {
  const performance = getPerformanceAPI();

  return (typeof performance !== 'undefined' && typeof performance.timing !== 'undefined');
}
